import ColumnMenuContext from '@components/Kendo/ColumnMenuContext';

export default ColumnMenuContext;
